import { axios } from '@/axios';
import routes from '@/web-api/routes';
import storageManager from '@/storage-manager';

const entities = [
  {
    route: routes.webapi.entities.jobTypes,
    key: 'jobTypes',
    actionName: 'getJobTypes',
    mappingFunction(item) {
      return item;
      // return {
      //   value: item.id,
      //   name: item.name,
      //   slug: item.slug,
      // };
    },
  },
  {
    route: routes.webapi.entities.jobRoles,
    key: 'jobRoles',
    actionName: 'getJobRoles',
    mappingFunction(item) {
      return item;
      // return {
      //   value: item.id,
      //   name: item.name,
      //   slug: item.slug,
      // };
    },
  },
  {
    route: routes.webapi.entities.genders,
    key: 'genders',
    actionName: 'getGenders',
    mappingFunction(item) {
      return item;
    },
  },
  {
    route: routes.webapi.entities.institutionStartYears,
    key: 'institutionStartYears',
    actionName: 'getInstitutionStartYears',
    mappingFunction(item) {
      return item;
    },
  },
  {
    route: routes.webapi.entities.emailFrequencies,
    key: 'emailFrequencies',
    actionName: 'getEmailFrequencies',
    mappingFunction(item) {
      return {
        value: item.id,
        name: item.frequency,
      };
    },
  },
  {
    route: routes.webapi.entities.companies,
    key: 'companies',
    actionName: 'getCompanies',
    mappingFunction(item) {
      return item;
    },
  },
  {
    route: routes.webapi.entities.ethnicities,
    key: 'ethnicities',
    actionName: 'getEthnicities',
    mappingFunction(item) {
      return item;
    },
  },
  {
    route: routes.webapi.entities.freeSchoolMeals,
    key: 'freeSchoolMeals',
    actionName: 'getFreeSchoolMeals',
    mappingFunction(item) {
      return item;
    },
  },
  {
    route: routes.webapi.entities.parentProfessions,
    key: 'parentProfessions',
    actionName: 'getParentProfessions',
    mappingFunction(item) {
      return item;
    },
  },
].map((entity) => {
  return {
    actionName: entity.actionName,
    actionFunction({ state, commit }) {
      const { key } = entity;

      const cacheKey = `${state.config.cacheNamespace}|${key}`;
      const cachedData = storageManager.getSessionStorage({ key: cacheKey });

      return new Promise((resolve, reject) => {
        if (cachedData !== null) {
          commit('setEntities', { key, items: cachedData });
          resolve(cachedData);
        }

        axios
          .get(entity.route)
          .then((response) => {
            const mappedData = response.data.data.map(entity.mappingFunction);

            // If there is only one item, return it as an object instead of an array
            // Job roles is the only entity returns as an array with one item in the API
            const items = mappedData.length === 1 ? mappedData[0] : mappedData;

            commit('setEntities', { key, items });
            storageManager.setSessionStorage({ key: cacheKey, items });

            return resolve(mappedData);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
  };
}).reduce((accumulator, entity) => {
  accumulator[entity.actionName] = entity.actionFunction;
  return accumulator;
}, {});

export default entities;
